module.exports = __webpack_public_path__ + "static/media/buddies.da29038c.png";